import { jsx } from "react/jsx-runtime";
import { Tooltip } from "@mui/material";
const TooltipWrapper = ({ title, children }) => {
  if (!title)
    return children;
  return /* @__PURE__ */ jsx(Tooltip, { placement: "top", arrow: true, title: title || "", children });
};
export {
  TooltipWrapper as default
};
